export default {
    name: "LightboxOverlay",

    data: {
        display: "hidden",
        htmlContent: ""
    },

    watch: {
        display() {
            // this.togglePlayback();
        }
    },

    created() {
        console.log(window.sette.emitter)
        window.sette.emitter.$on("lightbox.toggle", this.onLightboxToggle);
    },

    beforeDestroy() {
        window.sette.emitter.$off("lightbox.toggle", this.onLightboxToggle);
    },

    methods: {
        onLightboxToggle(htmlContent) {
            if (htmlContent) {
                this.htmlContent = htmlContent;
            }
            console.log(htmlContent)
            this.display = (this.display === "hidden") ? "visible" : "hidden";
        },

        togglePlayback() {
            const video = this.$el.querySelector("video");
            if (!video) {
                return;
            }
            if (this.display === "visible") {
                video.play();
            } else {
                video.pause();
                video.currentTime = 0;
            }
        }
    }
};